import React from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { AntSwitch } from "components/HeaderProject/components/SortListColumn";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import {
  DEFAULT_MESSAGE,
  SnackbarEmitter,
  SNACKBAR_VARIANT,
} from "constants/snackbarController";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getReportCategoriesSuccess,
  updateModalReport,
  updateStatusDefaultCategory,
} from "../../controllers/actions";
import {
  selectModalReport,
  selectReportCategories,
  selectStatusDefaultCategory,
} from "../../controllers/selectors";
import { apiService } from "constants/axiosInstance";
import ReportCreation from "../ReportCreation/ReportCreation";
import AlertModal from "components/AlertModal";
import PopoverMore from "../PopoverMore";
import { actionToast } from "actions/system/system";
import { viewPermissionsSelector } from "views/ProjectPage/selectors";
import { useParams } from "react-router-dom";

export const useStyles = makeStyles({
  btnEditReport: {
    minWidth: 30,
    maxWidth: 40,
    margin: "0px 3px",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  iconColor: {
    color: "#505050",
  },
  iconButton: {
    marginRight: "4px",
  },
  textExplain: {
    color: "#666",
  },
  containerCustomReport: {
    marginTop: 10,
  },
  gridContainer: {
    width: "100%",
  },
  nameContainer: {
    display: "flex",
    alignItems: "center",
  },
});

const ReportName = ({
  report = {},
  projectId,
  isCollapse,
  setIsCollapse,
  isDefault,
  handleEditCategory,
  isDefaultCategory = false,
  viewPermissions,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleToast = async (type, message) => {
    dispatch(actionToast(type, message));
    setTimeout(() => dispatch(actionToast(null, "")), 2000);
  };
  const [alertReportItem, setAlertReportItem] = React.useState(false);
  const reportCategories = useSelector(selectReportCategories());
  const statusDefaultCategory = useSelector(selectStatusDefaultCategory());
  const { name = "", description = "", is_hidden = false, id = "" } = report;
  const { openCreateReport, selectedReport, edit } = useSelector(
    selectModalReport()
  );
  console.log(viewPermissions, "viewPermissions");
  const isWebview = document.location.pathname.search("webview") !== -1;
  const canUpdate =
    viewPermissions?.permissions?.[projectId]?.update_project ?? false;
  return (
    <Grid
      className={classes.gridContainer}
      container
      direction="row"
      justifyContent="space-between"
    >
      <Grid
        item
        onClick={() => {
          setIsCollapse(!isCollapse);
        }}
        sx={{ cursor: "pointer" }}
      >
        <div className={classes.nameContainer}>
          <Typography variant="h6" component="div" sx={{ cursor: "pointer" }}>
            {!isDefaultCategory && name}
            {isDefaultCategory && t("views.report_page.DES_REPORT_DEFAULT")}
          </Typography>
          {!isCollapse && !isDefaultCategory && (
            <Grid item>
              <ArrowDropDownIcon className={classes.iconColor} />
            </Grid>
          )}
          {isCollapse && !isDefaultCategory && (
            <Grid item>
              <ArrowRightIcon className={classes.iconColor} />
            </Grid>
          )}
        </div>
        <Typography
          component="p"
          className={classes.textExplain}
          sx={{ cursor: "pointer" }}
        >
          {!isDefaultCategory && description}
          {isDefaultCategory && t("views.report_page.DES_REPORT_DEFAULT")}
        </Typography>
      </Grid>

      <Grid item>
        <Grid container direction="row" alignItems="center">
          <div
            style={{
              cursor: canUpdate ? "pointer" : "not-allowed",
            }}
          >
            {t("views.report_page.SHOW_HIDE")}
            <AntSwitch
              disabled={!canUpdate}
              defaultChecked={
                isDefaultCategory ? statusDefaultCategory === 1 : !is_hidden
              }
              onChange={async (e) => {
                try {
                  if (isDefaultCategory) {
                    let response;
                    try {
                      response = await apiService({
                        url: "/project/report/set-status-category-default",
                        method: "POST",
                        data: {
                          project_id: projectId,
                          status: e.target.checked ? 1 : 2,
                        },
                      });
                      if (response?.data?.state) {
                        dispatch(
                          updateStatusDefaultCategory(
                            statusDefaultCategory === 1 ? 2 : 1
                          )
                        );
                        SnackbarEmitter(
                          SNACKBAR_VARIANT.SUCCESS,
                          DEFAULT_MESSAGE.MUTATE.SUCCESS
                        );
                      } else {
                        SnackbarEmitter(
                          SNACKBAR_VARIANT.ERROR,
                          response?.msg ?? DEFAULT_MESSAGE.MUTATE.ERROR
                        );
                      }
                    } catch (e) {
                      SnackbarEmitter(
                        SNACKBAR_VARIANT.ERROR,
                        response?.msg ?? DEFAULT_MESSAGE.MUTATE.ERROR
                      );
                    }
                    return;
                  }
                  const response = await apiService({
                    url: "/project/report/set-status-category",
                    method: "POST",
                    data: {
                      category_id: id,
                      status: e.target.checked ? 1 : 2,
                    },
                  });
                  let tmp = reportCategories.map((cate) => {
                    if (cate.id === id) {
                      return {
                        ...cate,
                        is_hidden: !cate.is_hidden,
                      };
                    }
                    return cate;
                  });
                  if (response?.data?.state) {
                    dispatch(getReportCategoriesSuccess(tmp));
                    SnackbarEmitter(
                      SNACKBAR_VARIANT.SUCCESS,
                      DEFAULT_MESSAGE.MUTATE.SUCCESS
                    );
                  } else {
                    SnackbarEmitter(
                      SNACKBAR_VARIANT.ERROR,
                      response?.msg ?? DEFAULT_MESSAGE.MUTATE.ERROR
                    );
                  }
                } catch (e) {
                  SnackbarEmitter(
                    SNACKBAR_VARIANT.ERROR,
                    DEFAULT_MESSAGE.MUTATE.ERROR
                  );
                }
              }}
              inputProps={{ "aria-label": "ant design" }}
            />
          </div>
          {!isDefaultCategory && canUpdate && !isWebview && (
            <Button variant="text" className={classes.btnEditReport}>
              <AddIcon
                className={classes.iconColor}
                onClick={() => {
                  dispatch(
                    updateModalReport({
                      edit: false,
                      openCreateReport: true,
                      selectedReport: {
                        category_id: report?.id,
                      },
                    })
                  );
                }}
              />
            </Button>
          )}
          {!isDefaultCategory && canUpdate && !isWebview && (
            <PopoverMore
              items={[
                !isDefault && {
                  title: t("IDS_WP_EDIT"),
                  onClick: () => {
                    handleEditCategory(report);
                  },
                },
                !isDefault && {
                  title: t("IDS_WP_DELETE"),
                  onClick: () => {
                    setAlertReportItem(true);
                  },
                  sx: { color: "red" },
                },
              ]}
            >
              <Button variant="text" className={classes.btnEditReport}>
                <MoreHorizIcon className={classes.iconColor} />
              </Button>
            </PopoverMore>
          )}
        </Grid>
      </Grid>

      {openCreateReport && selectedReport?.category_id === report?.id && (
        <ReportCreation
          open={openCreateReport}
          setOpen={(value) => {
            dispatch(
              updateModalReport({
                edit: false,
                openCreateReport: value,
              })
            );
          }}
          selectedReport={selectedReport}
          edit={edit}
          onFinish={({ name, description, newReport }) => {
            const arr = reportCategories.map((item) => {
              if (item.id === report.id) {
                const clone = JSON.parse(JSON.stringify(item));
                if (!edit) {
                  if (newReport) {
                    clone.reports = (clone?.reports ?? []).concat(newReport);
                  }
                } else {
                  clone.reports = clone.reports?.map((e) => {
                    if (e.id === selectedReport.id) {
                      return {
                        ...e,
                        name,
                        description,
                      };
                    }
                    return e;
                  });
                }

                return clone;
              }
              return item;
            });
            dispatch(
              updateModalReport({
                edit: false,
                openCreateReport: false,
              })
            );
            dispatch(getReportCategoriesSuccess(arr));
            setIsCollapse(true);
          }}
        />
      )}

      <AlertModal
        open={alertReportItem}
        setOpen={setAlertReportItem}
        content={t("IDS_WP_ALERT_CONTENT")}
        onConfirm={async () => {
          try {
            const response = await apiService({
              url: "/project/report/delete-category",
              method: "POST",
              data: {
                category_id: report.id,
              },
            });
            if (response?.data?.state) {
              const arr = reportCategories.filter(
                (item) => item.id !== report.id
              );
              dispatch(getReportCategoriesSuccess(arr));
              handleToast("success", t("IDS_WP_DELETE_COMPLETE"));
            } else {
              SnackbarEmitter(
                SNACKBAR_VARIANT.ERROR,
                response?.data?.msg ?? DEFAULT_MESSAGE.MUTATE.ERROR
              );
            }
          } catch (err) {
            SnackbarEmitter(
              SNACKBAR_VARIANT.ERROR,
              DEFAULT_MESSAGE.MUTATE.ERROR
            );
          }
        }}
      />
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    viewPermissions: viewPermissionsSelector(state),
  };
};

export default connect(mapStateToProps, (state) => {})(ReportName);
